import i18n from "@/i18n";
import lang from "@/config/languags.config.json";
import { ILocale as ILocaleArr } from "@/@types/locales";
import { ILocale } from "@/@types/locale";

export function getLocale(data: ILocale): string {
  if (!data) return "ㅤ";
  const pref = lang.preferred_language;
  const i18pref = String(i18n.fallbackLocale);
  const keys = Object.keys(data);

  if (keys.includes(i18n.locale)) return data[i18n.locale] || "ㅤ";
  if (keys.includes(pref)) return data[pref] || "ㅤ";
  if (keys.includes("en")) return data["en"] || "ㅤ";
  if (keys.includes(i18pref)) return data[i18pref] || "ㅤ";

  return keys.length ? data[keys[0]] : "ㅤ";
}

export function curentIndex(arr: Array<ILocaleArr>): number | null {
  if (!arr.length) return null;
  if (arr.length === 0) return null;
  for (let i = 0; i < arr.length; i++) {
    if (i18n.locale == arr[i].lang) {
      return i;
    }
  }
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].lang == "en") {
      return i;
    }
  }
  for (let i = 0; i < arr.length; i++) {
    if (lang.preferred_language == arr[i].lang) {
      return i;
    }
  }
  for (let i = 0; i < arr.length; i++) {
    if (i18n.fallbackLocale == arr[i].lang) {
      return i;
    }
  }

  return 0;
}

export function givenLocale(text: ILocale, locale: string): string {
  if (!text) return "";
  const keys = Object.keys(text);
  if (keys.includes(locale)) return text[locale];
  return "ᅠ";
}
